import { render, staticRenderFns } from "./AssociatedImagesSidePanel.vue?vue&type=template&id=be21edb0&"
import script from "./AssociatedImagesSidePanel.vue?vue&type=script&lang=js&"
export * from "./AssociatedImagesSidePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports